


































import { defineComponent } from "@vue/composition-api";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";

export default defineComponent({
  name: "VideoBundleUnlockingLogsTableCell",
  components: {
    OccLabel
  },
  props: {
    mainLabel: {
      type: String,
      default: ""
    },
    subLabels: {
      type: Array,
      default: () => []
    }
  }
});
